import React from "react";
import { Button, Flyout, FlyoutFullScreen, Icon } from "@accessdev/arc-ui-react";
import Media from "react-media";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";
import classNames from "classnames";
import { buildAddress } from "../utils";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

function Location({ handleLocationClick, address, distance, isCurrentLocation = false }) {
  return (
    <button className="offer-moreLocations_location t-body-med" onClick={handleLocationClick}>
      <span
        className={classNames("offer-moreLocations_location-icon", {
          bold: isCurrentLocation,
        })}
      >
        <div>{address !== "Online only" ? t`${distance} Away` : t`0 mi Away`}</div>
      </span>
      <span
        className={classNames("offer-moreLocations_location-address", {
          bold: isCurrentLocation,
        })}
        dangerouslySetInnerHTML={{ __html: address }}
      />
    </button>
  );
}

function MoreLocations({ allLocations, selectLocation, selectedLocation, store }) {
  useLingui();
  const [moreLocationsOpen, setMoreLocationsOpen] = React.useState(false);
  const triggerRef = React.useRef(null);
  const triggerId = "MoreLocations-triggerBtn";

  const locations = allLocations.filter(
    (location) => location.location_id !== selectedLocation.location_id,
  );
  const handleLocationClick = (location) => {
    selectLocation(location);
    setMoreLocationsOpen(false);
    triggerRef.current.focus();
  };

  const renderMoreLocations = () => (
    <React.Fragment>
      {locations.map((location) => (
        <Location
          key={location.location_id}
          address={buildAddress(location, true)}
          distance={location.distance}
          handleLocationClick={() => handleLocationClick(location)}
        />
      ))}
    </React.Fragment>
  );

  const closeFlyout = () => {
    setMoreLocationsOpen(false);
    triggerRef.current.focus();
  };

  return (
    <React.Fragment>
      <Button
        ref={triggerRef}
        onClick={() => setMoreLocationsOpen(true)}
        displayStyle={"link"}
        icon={"expand_more"}
        iconPosition={"right"}
        size="large"
        additionalProps={{
          "id": triggerId,
          "aria-label": t`More Locations`,
          "aria-haspopup": "true",
        }}
        className="button-offer-location"
      >
        <div className="offer-locations_distance t-body-med">
          {selectedLocation?.geo_location?.lat !== 0
            ? t`${selectedLocation.distance} Away`
            : t`0 mi Away`}
        </div>
        <div className="offer-locations_current t-body-med more-location">
          <p
            className="offer-locations_currentAddress"
            dangerouslySetInnerHTML={{
              __html: buildAddress(selectedLocation, true),
            }}
          />
        </div>
      </Button>
      <Media query={mediaBreakpoints.forPhoneOnly}>
        {(isPhone) =>
          !isPhone ? (
            <Flyout
              anchorId={triggerId}
              isOpen={moreLocationsOpen}
              onClose={() => closeFlyout()}
              fixedPosition={true}
              useTabTrapping={true}
              defaultPadding={false}
            >
              <div className="offer-moreLocations">{renderMoreLocations()}</div>
            </Flyout>
          ) : (
            <FlyoutFullScreen defaultPadding={false} isOpen={moreLocationsOpen}>
              <div className="offer-moreLocationsMobile">
                <header>
                  <h3>{store.name}</h3>
                  <span>
                    <Icon
                      icon="close"
                      onClick={() => closeFlyout()}
                      type="button"
                      title={t`Close locations`}
                    />
                  </span>
                </header>
                <div className="offer-moreLocationsMobile-current">
                  <Location
                    isCurrentLocation={true}
                    address={buildAddress(selectedLocation, true)}
                    distance={selectedLocation.distance}
                  />
                  <hr />
                </div>
                <div className="offer-moreLocationsMobile-more">{renderMoreLocations()}</div>
              </div>
            </FlyoutFullScreen>
          )
        }
      </Media>
    </React.Fragment>
  );
}

export default MoreLocations;
